import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';
import MobileNavOverlay from './MobileNavOverlay';
import AmigosWordmark from './AmigosWordmark';

const LINKS = [
  { to: '/', key: 'home' },
  { to: '/services', key: 'services' },
  { to: '/areas', key: 'areas' },
  { to: '/how-bail-works', key: 'how' },
  { to: '/faq', key: 'faq' },
  { to: '/contact', key: 'contact' },
];

const MainNav = () => {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <>
      <nav className="main-nav" data-testid="main-nav">
        <div className="main-nav__inner">
          <Link to="/" className="main-nav__logo" data-testid="nav-logo-link" style={{ textDecoration: 'none' }}>
            <AmigosWordmark size="md" subline="license" testId="main-nav-wordmark" />
          </Link>
          <div className="main-nav__links">
            {LINKS.map((l) => (
              <Link key={l.to} to={l.to} className={`nav-link ${location.pathname === l.to ? 'active' : ''}`} data-testid={`nav-link-${l.key}`}>
                {t(`nav.${l.key}`)}
              </Link>
            ))}
          </div>
          <div className="main-nav__actions">
            <Link to="/start-a-bond" className="btn-red" style={{ padding: '0.65rem 1.3rem', fontSize: '0.82rem' }} data-testid="nav-start-bond-btn">
              {t('nav.startBond')}
            </Link>
            <button className="nav-toggle" onClick={() => setOpen(true)} aria-label="Open menu" data-testid="nav-mobile-toggle">
              <Menu size={20} />
            </button>
          </div>
        </div>
      </nav>
      <MobileNavOverlay open={open} onClose={() => setOpen(false)} phoneDisplay="(936) 828-2500" phoneTel="9368282500" />
    </>
  );
};

export default MainNav;
